import ListStore from '@/store/core/ListStore';
import { action } from 'mobx';
import services from '@/api/services';

export default class PlatformsTaxpayerReceiptImageStore extends ListStore<any> {
  @action.bound async fetch(mid: string) {
    this.isFetching = true;
    try {
      const { data } = await services.receipts.getReceiptImage(
        mid
      );
      const url = URL.createObjectURL(data);
      Object.assign(document.createElement('a'), { href: url, download: `receipt-${mid}.png` })
        .click();
      URL.revokeObjectURL(url);
      console.log(data)
    } catch (e) {
      console.error(e);
    } finally {
      this.isFetching = false;
    }
  }
}


